import { Box, Grid2 as Grid, ThemeProvider, Typography } from "@mui/material";
import { default as React, useContext, useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css"; // Don't forget this import for styles
import { SocialMediaDetails } from "../../utils/constants";
import { GlobalContext } from "../../utils/GlobalContext";
import "../Assets/css/index.css";
import Profile from "../Assets/Img/userprofileimg.png";
import axiosMain from "../http/axiosMain";
import { theme } from "./SetupProfile/constant";

/** icons */
import { FaRegCircleCheck } from "react-icons/fa6";
import { FiCreditCard, FiPhone } from "react-icons/fi";
import { GoPerson } from "react-icons/go";
import { GrLocation } from "react-icons/gr";
import { MdOutlineMail } from "react-icons/md";
import { RiBankLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import BackVector from "../Assets/Img/BackVector.svg";
import { RiVerifiedBadgeFill } from "react-icons/ri";
import EditIcon from "../Assets/Img/edit-icon.svg";
import VerifiedIcon from "../Assets/Img/verified.svg";
import WebsiteIcon from "../Assets/Img/website.svg";
import { SetupBrandProfile } from "./SetupProfile/brand";

export default function MyProfile() {
  const { setUserData: setContextUserData, userData: contextUserData } =
    useContext(GlobalContext);
  const [showEditProfileModal, setShowEditProfileModal] = useState(false);
  const isAdminAddprofile = localStorage.getItem("isAdminAddprofile");

  const navigate = useNavigate();
  const role = localStorage.getItem("userType");

  const fetchBrandProfile = async () => {
    try {
      let response = await axiosMain.get("/api/v1/get-brand-profile");

      if (
        response.data?.user &&
        Object.keys(response.data?.user || {})?.length
      ) {
        setContextUserData({
          ...(response?.data?.user || {}),
          categories: response.data?.categories || [],
        });
        localStorage.setItem("user", JSON.stringify(response.data));
      }

      const brandName = response.data?.user?.brand_name; 

      if (brandName) {
        localStorage.setItem("brandName", brandName);
      }
    } catch (error) {
      console.error("Error fetching brand profile:", error);
    }
  };

  useEffect(() => {
    fetchBrandProfile();
  }, []);

  // Toggle modal visibility for Edit Profile
  const handleCloseEditProfileModal = () => setShowEditProfileModal(false);
  const handleBackNavigation = () => {
    if (role === "influencer") {
      navigate("/influencer-home");
      fetchBrandProfile();
    } else if (role === "brand") {
      navigate("/brand-home");
      fetchBrandProfile();
    } else {
      navigate("/"); // Default navigation (e.g., homepage)
    }
  };

  return (
    <>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        mb={2}
        alignItems={"center"}
      >
        <button onClick={handleBackNavigation} className="navback-button">
          <img src={BackVector} alt="back" className="back-vactor" />
          Back
        </button>
        {/* {localStorage.getItem("userType") === "influecer" && ( */}
        <Box
          width={"48px"}
          height={"48px"}
          borderRadius={"24px"}
          sx={{ cursor: "pointer" }}
          onClick={() => setShowEditProfileModal(true)}
        >
          <img src={EditIcon} alt="edit" />
        </Box>
        {/* )} */}
      </Box>
      <ThemeProvider theme={theme}>
        {contextUserData?.approve_status === "pending" ? (
          <Box
            sx={{
              bgcolor: "#F8F3B5",
              borderRadius: "8px",
              padding: "8px 24px",
              marginBottom: "10px",
            }}
          >
            <Typography color="#F7B402">
              Your Profile has been sent for verification! We will Get back to
              you soon...
            </Typography>
          </Box>
        ) : (
          <></>
        )}
        <Box display={"flex"} flexDirection={"column"} rowGap={"32px"}>
          <Box>
            <Box
              sx={{
                border: "1px solid #EEEEEE",
                display: "flex",
                alignItems: "start",
                padding: "1.5rem 2.5rem",
                borderRadius: "1rem",
                gap: "12px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flex: 1,
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <Box
                  sx={{
                    width: "120px",
                    height: "120px",
                    overflow: "hidden",
                    borderRadius: "77px",
                    border: "1.09px solid #F3F3F3",
                  }}
                >
                  <img
                    src={contextUserData?.user_photo || Profile}
                    alt="Puma Logo"
                    style={{
                      width: "120px",
                      height: "120px",
                      overflow: "hidden",
                      objectFit: "cover",
                    }}
                  />
                </Box>
                <Box>
                  <Box display={"flex"} alignItems={"center"} gap={1}>
                    {contextUserData?.role === "brand" ? (
                      <Typography fontWeight={600} fontSize={"24px"}>
                        {contextUserData?.brand_name}
                      </Typography>
                    ) : (
                      <></>
                    )}
                    {contextUserData?.role === "influencer" ? (
                      <>
                        <Typography fontWeight={600} fontSize={"24px"}>
                          {[
                            contextUserData?.first_name,
                            contextUserData?.last_name,
                          ]
                            .filter(Boolean)
                            .join(" ")}{" "}
                        </Typography>
                      </>
                    ) : (
                      <></>
                    )}
                    {contextUserData?.approve_status === "approved" ? (
                      <Box
                        height={"28px"}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          padding: "4px 8px",
                          gap: "4px",
                          background: "#E9FFDF",
                          color: "#6B8E76",
                          borderRadius: "14px",
                        }}
                      >
                        <RiVerifiedBadgeFill />
                        <Typography fontSize={"12px"}>Verified</Typography>
                      </Box>
                    ) : (
                      <></>
                    )}
                  </Box>
                  {contextUserData?.age &&
                  contextUserData?.role === "influencer" ? (
                    <Typography fontSize={"13px"} color="#656565">
                      Age:{" "}
                      <span style={{ fontWeight: 500 }}>
                        {contextUserData?.age || 0} Years
                      </span>
                    </Typography>
                  ) : (
                    <></>
                  )}
                  {contextUserData?.role === "brand" ? (
                    <Typography fontSize={"13px"} color="#656565">
                      Registered By:{" "}
                      <span style={{ fontWeight: 500 }}>
                        {[
                          contextUserData?.first_name,
                          contextUserData?.last_name,
                        ]
                          .filter(Boolean)
                          .join(" ")}
                      </span>
                      , {contextUserData?.position || "N/A"}
                    </Typography>
                  ) : (
                    <></>
                  )}
                  <Typography fontSize={"13px"} color="#656565">
                    Category(ies):{" "}
                    <span style={{ fontWeight: 500 }}>
                      {contextUserData?.categories?.filter(Boolean)?.length > 0
                        ? contextUserData?.categories
                            ?.filter(Boolean)
                            .join(", ")
                        : "No categories available"}
                    </span>
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              border: "1px solid #EEEEEE",
              display: "flex",
              alignItems: "start",
              padding: "1.5rem 2.5rem",
              borderRadius: "1rem",
              gap: "12px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flex: 1,
                flexDirection: "column",
                gap: "32px",
              }}
            >
              <Box display={"flex"} gap={"12px"} flexDirection={"column"}>
                <Typography fontSize={"20px"} fontWeight={600}>
                  Bio
                </Typography>
                <Typography fontSize={"1rem"} fontWeight={400} color="#656565">
                  {contextUserData?.bio || "N/A"}
                </Typography>
              </Box>
              {isAdminAddprofile === "app" ? (
                <Box display={"flex"} gap={"12px"} flexDirection={"column"}>
                  <Typography fontSize={"20px"} fontWeight={600}>
                    Contact Details
                  </Typography>
                  <Box display={"flex"} alignItems={"center"} gap={"1.5rem"}>
                    <Box
                      display={"flex"}
                      gap={"8px"}
                      color={"#656565"}
                      alignItems={"center"}
                      fontSize={"1rem"}
                    >
                      <FiPhone />
                      <Typography>
                        Phone:{" "}
                        {contextUserData?.phone_no ? (
                          <a
                            style={{ fontWeight: 500, color: "#6B8E76" }}
                            href={`tel:${contextUserData.phone_no}`}
                          >
                            {contextUserData.phone_no}
                          </a>
                        ) : (
                          "N/A"
                        )}
                      </Typography>
                    </Box>
                    <Box
                      display={"flex"}
                      gap={"8px"}
                      color={"#656565"}
                      alignItems={"center"}
                      fontSize={"1rem"}
                    >
                      <MdOutlineMail />
                      <Typography>
                        Email:{" "}
                        {contextUserData?.email ? (
                          <a
                            style={{ fontWeight: 500, color: "#6B8E76" }}
                            href={`mailto:${contextUserData.email}`}
                          >
                            {contextUserData.email}
                          </a>
                        ) : (
                          "N/A"
                        )}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              ) : (
                <></>
              )}
              <Box display={"flex"} gap={"12px"} flexDirection={"column"}>
                <Typography fontSize={"20px"} fontWeight={600}>
                  Location
                </Typography>
                <Box
                  display={"flex"}
                  gap={"8px"}
                  color={"#656565"}
                  alignItems={"center"}
                  fontSize={"1rem"}
                >
                  <GrLocation />
                  <Typography
                    fontSize={"1rem"}
                    fontWeight={400}
                    color="#656565"
                  >
                    Location:{" "}
       <span style={{ fontWeight: 500 }}>
  {[
    contextUserData?.address || "",
    contextUserData?.address_line_2 || "",
    contextUserData?.city?.city_name || contextUserData?.city || "",
    contextUserData?.state?.state_name || contextUserData?.state || "",
    contextUserData?.pincode || "",
  ]
    .filter((x) => x && x.trim() !== "")
    .join(", ") || "N/A"}
</span>


                  </Typography>
                </Box>
              </Box>
              <Box display={"flex"} gap={"12px"} flexDirection={"column"}>
                <Typography fontSize={"20px"} fontWeight={600}>
                  Social media Links
                </Typography>
                <Box
                  display={"flex"}
                  gap={"8px"}
                  color={"#656565"}
                  alignItems={"center"}
                  fontSize={"1rem"}
                >
                  {contextUserData?.brand_website ? (
                    <Box
                      height={"28px"}
                      sx={{
                        display: "flex",
                        padding: "4px 8px",
                        gap: "4px",
                        background: "#6B8E7614",
                        color: "#6B8E76",
                        borderRadius: "14px",
                        alignItems: "center",
                      }}
                    >
                      <img src={WebsiteIcon} alt="website" />
                      <Typography fontSize={"12px"}>
                        {contextUserData.brand_website}
                      </Typography>
                    </Box>
                  ) : (
                    <></>
                  )}
                  {contextUserData?.socialLinks?.map((i) => {
                    const { icon, color, bgColor } = SocialMediaDetails[i.type];

                    return (
                      <Box
                        height={"28px"}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          padding: "4px 8px",
                          gap: "4px",
                          background: bgColor,
                          color: color,
                          borderRadius: "14px",
                        }}
                      >
                        {icon({ size: "18px" })}
                        <Typography fontSize={"12px"}>{i.link}</Typography>
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              border: "1px solid #EEEEEE",
              display: "flex",
              alignItems: "start",
              padding: "1.5rem 2.5rem",
              borderRadius: "1rem",
              gap: "12px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flex: 1,
                flexDirection: "column",
                gap: "32px",
              }}
            >
              <Box display={"flex"} gap={"12px"} flexDirection={"column"}>
                <Typography fontSize={"20px"} fontWeight={600}>
                  Bank Details
                </Typography>
                <Box>
                  <Grid container spacing={2}>
                    <Grid size={6}>
                      <Box display={"flex"} alignItems={"center"} gap={1}>
                        <GoPerson />
                        <Typography color="#656565" fontWeight={400}>
                          Account Holder Name:{" "}
                          <span style={{ fontWeight: 500 }}>Jon Doe</span>
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid size={6}>
                      <Box display={"flex"} alignItems={"center"} gap={1}>
                        <RiBankLine />
                        <Typography color="#656565" fontWeight={400}>
                          Bank Name:{" "}
                          <span style={{ fontWeight: 500 }}>Dena Bank</span>
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid size={6}>
                      <Box display={"flex"} alignItems={"center"} gap={1}>
                        <FaRegCircleCheck />
                        <Typography color="#656565" fontWeight={400}>
                          Account Number:{" "}
                          <span style={{ fontWeight: 500 }}>12345678901</span>
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid size={6}>
                      <Box display={"flex"} alignItems={"center"} gap={1}>
                        <FiCreditCard />
                        <Typography color="#656565" fontWeight={400}>
                          IFSC code:{" "}
                          <span style={{ fontWeight: 500 }}>KM0694</span>
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
              <Box display={"flex"} gap={"12px"} flexDirection={"column"}>
                <Typography fontSize={"20px"} fontWeight={600}>
                  UPI ID
                </Typography>
                <Box display={"flex"} gap={1} alignItems={"center"}>
                  <Typography>jondoe@okicici.com</Typography>
                  <img src={VerifiedIcon} alt="website" />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
        {showEditProfileModal ? (
          <SetupBrandProfile
            open={showEditProfileModal}
            onClose={handleCloseEditProfileModal}
            isEdit={true}
          />
        ) : (
          <></>
        )}
      </ThemeProvider>
    </>
  );
}
